import { TDispatch } from '../type';
import { TFeatureToggleState } from './featureToggle.type';

export const featureToggleReducer = (state: TFeatureToggleState, { type, payload }: TDispatch): TFeatureToggleState => {
  switch (type) {
    case 'features_load':
      return {
        ...state,
        isFetching: true,
        isFetched: false,
        data: null,
        error: null,
      };
    case 'features_load_success':
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        data: payload as TFeatureToggleState['data'],
        error: null,
      };
    case 'features_load_error':
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        data: null,
        error: payload as TFeatureToggleState['error'],
      };
    default:
      return state;
  }
};

featureToggleReducer.key = 'features';
featureToggleReducer.initialState = {
  isFetching: false,
  isFetched: false,
  data: null,
  error: null,
};

export default { featureToggleReducer };
